import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { loadShopifyAppBridge } from "./lib/appBridge";
import "./styles.css";

async function start() {
  await loadShopifyAppBridge();
  ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>);
}

void start();
